// removed by extract-text-webpack-plugin
module.exports = {"footerWrapper":"style__footerWrapper___3HWjU","footerIcon":"style__footerIcon___39s7j"};


//////////////////
// WEBPACK FOOTER
// ./components/Footer/style.scss
// module id = ./components/Footer/style.scss
// module chunks = 5